import { render } from "./PlanningSafety.vue?vue&type=template&id=72caa12c&scoped=true"
import script from "./PlanningSafety.vue?vue&type=script&lang=js"
export * from "./PlanningSafety.vue?vue&type=script&lang=js"

import "./PlanningSafety.vue?vue&type=style&index=0&id=72caa12c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72caa12c"]])

export default __exports__